// cspell:words Evett
import { memo } from "react";
import * as css from "./thursday-boot-warning-banner.module.css";

const THURSDAY_BOOT_TEAM_ID = "65fb04bbb4a972000754cbdc";
const REDO_EMAIL_DOMAINS = ["@redo.com", "@getredo.com"];

function isRedoEmail(email: string): boolean {
  return REDO_EMAIL_DOMAINS.some((domain) => email.endsWith(domain));
}

export const ThursdayBootWarningBanner = memo(
  function ThursdayBootWarningBanner({
    teamId,
    email,
  }: {
    teamId: string | undefined;
    email: string | undefined;
  }) {
    if (!teamId || !email) return null;
    if (teamId !== THURSDAY_BOOT_TEAM_ID) return null;
    if (!isRedoEmail(email)) return null;

    return (
      <div
        className={css.banner}
        data-testid="thursday-boot-warning-banner"
        role="alert"
      >
        <span aria-hidden className={css.icon}>
          ⚠
        </span>
        <span className={css.message}>
          <strong>WARNING:</strong> Making ANY changes to Thursday Boot
          Company&apos;s settings, orders, or data without explicit permission
          from Aaron Evett is a fireable offense.
        </span>
        <span aria-hidden className={css.icon}>
          ⚠
        </span>
      </div>
    );
  },
);
